import { Box, ButtonBase, Paper, Typography } from "@mui/material";
import DatasetIcon from "@mui/icons-material/Dataset";
import { useNavigate } from "react-router-dom";
import t from "./translations";

type Tool = {
  key: string;
  label: string;
  path: string;
  icon: React.ReactNode;
};

const TOOLS: Tool[] = [
  {
    key: "datasets",
    label: t.tools.datasets,
    path: "/datasets",
    icon: <DatasetIcon sx={{ fontSize: 64 }} />,
  },
];

const PANEL_SIZE = 240;
const GRID_COLUMNS = 4;
const GRID_GAP = 24;
const GRID_MAX_WIDTH = GRID_COLUMNS * PANEL_SIZE + (GRID_COLUMNS - 1) * GRID_GAP;

export default function Splash() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        p: 4,
      }}
      data-testid="splash-page"
    >
      <Typography variant="h4" component="h1" sx={{ alignSelf: "flex-start", mb: 4 }}>
        {t.title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: `${GRID_GAP}px`,
          maxWidth: GRID_MAX_WIDTH,
        }}
      >
        {TOOLS.map((tool) => (
          <ButtonBase
            key={tool.key}
            onClick={() => navigate(tool.path)}
            data-testid={`tool-panel-${tool.key}`}
            sx={{ borderRadius: 2 }}
          >
            <Paper
              elevation={2}
              sx={{
                width: PANEL_SIZE,
                height: PANEL_SIZE,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                transition: "box-shadow 0.2s, transform 0.2s",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
              }}
            >
              {tool.icon}
              <Typography variant="h6" component="span">
                {tool.label}
              </Typography>
            </Paper>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
}
